/**
 * Server functions backing the generic user-to-user referral page.
 * Thin wrappers: auth + delegation to `~/lib/server/referral`.
 * Aliases: referral, refer a friend, invite
 */
import { createServerFn } from "@tanstack/react-start";

import { authMiddleware } from "~/lib/auth-middleware";

export interface ReferredUser {
  id: string;
  firstName: string | null;
  lastName: string | null;
  createdAt: Date | null;
}

export interface UserReferralInfo {
  referralCode: string;
  referredUsers: ReferredUser[];
}

export const getUserReferralInfo = createServerFn({ method: "GET" })
  .middleware([authMiddleware])
  .handler(async ({ context }): Promise<UserReferralInfo> => {
    const { getDBWithInit } = await import("~/lib/db");
    const { ensureUserReferralCode, getReferredUsers } =
      await import("~/lib/server/referral");

    const db = await getDBWithInit();
    const userId = context.user.id;

    const [referralCode, referredUsers] = await Promise.all([
      ensureUserReferralCode(db, userId),
      getReferredUsers(db, userId),
    ]);

    return { referralCode, referredUsers };
  });
